import { createStoreChunk } from '@core/store'
import type { TDialogId } from './types'

/**
 * Which global dialog (if any) is open — muse-stack replacement for audio-web's `DialogManager`.
 * A single `activeDialog` (not audio-web's one-at-a-time queue) is intentional for the migration
 * start. Dialog-specific data lives in the owning feature's store — core stays feature-agnostic.
 */

type TModalState = { activeDialog: TDialogId | null }

export const modalStore = createStoreChunk<TModalState>('modal')({
    initialState: { activeDialog: null },
    actions: {
        open: (activeDialog: TDialogId) => ({ activeDialog }),
        close: () => ({ activeDialog: null }),
    },
})
